/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function CreateDataEntryLinkRequestFromJSON(json) {
    return CreateDataEntryLinkRequestFromJSONTyped(json, false);
}
export function CreateDataEntryLinkRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        path: json['path'],
        versionIds: json['versionIds'],
        filterTagIds: json['filterTagIds'],
        intervalStart: new Date(json['intervalStart']),
        intervalEnd: new Date(json['intervalEnd']),
        duration: json['duration'],
    };
}
export function CreateDataEntryLinkRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        path: value.path,
        versionIds: value.versionIds,
        filterTagIds: value.filterTagIds,
        intervalStart: value.intervalStart.toISOString().substr(0, 10),
        intervalEnd: value.intervalEnd.toISOString().substr(0, 10),
        duration: value.duration,
    };
}
